import { forwardRef, memo, useMemo, type Component } from 'react';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Box, { type BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Skillmore UI Components
import { getFullName } from '@empathco/ui-components/src/helpers/strings';
// local imports
import { EmployeeBrief } from '../models/employee';
// SCSS imports
import { leaderName } from './LeaderHeader.module.scss';

type LeaderHeaderProps = {
  readonly leader: EmployeeBrief;
};

const LeaderHeader = forwardRef<Component<BoxProps>, LeaderHeaderProps>(({
  leader: { first_name, last_name, code }
}, ref) => {
  const leaderValues = useMemo(() => ({ name: getFullName(first_name, last_name, code) }),
    [first_name, last_name, code]);
  return (
    <Box
        ref={ref}
        display="flex"
        alignItems="center"
        color="text.secondary"
        className={leaderName}
    >
      <Typography variant="subtitle1">
        <FormattedMessage id="header.acting_as" values={leaderValues}/>
      </Typography>
    </Box>
  );
});

LeaderHeader.displayName = 'LeaderHeader';

export default memo(LeaderHeader);
